module.exports = __webpack_public_path__ + "room_replaced.svg?80042bbf6e0bfae0818e33ab47a4a8fe";